import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config'
import {SolrRequestOptionsDTO} from '@signature-it/ngx-generic/models';
import { PageNotificationService } from './page-notification';
import { CommonService } from './common.service'
import {SolrService} from "./solr.service";


@Injectable({
    providedIn: 'root'
})
export class GadgetApiService extends CommonService {

    protected listUrl = `${this.restUrlsConf.appURL}/public/gadget/list.json`;
    protected gaugeUrl = `${this.restUrlsConf.appURL}/public/gadget/gauge.json`;
    protected cardUrl = `${this.restUrlsConf.appURL}/public/gadget/card.json`;
    protected barUrl = `${this.restUrlsConf.appURL}/public/gadget/bar.json`;
    protected bar2Url = `${this.restUrlsConf.appURL}/public/gadget/bar2.json`;
    protected pieByViewUrl = `${this.restUrlsConf.appURL}/public/gadget/pie_by_view.json`;
    protected gridUrl = `${this.restUrlsConf.appURL}/public/gadget/grid.json`;
    protected trendBarUrl = `${this.restUrlsConf.appURL}/public/gadget/trend_bar.json`;
    protected analyticsPeriodUrl = `${this.restUrlsConf.appURL}/public/codesc_by_codesc_var`;
    private solrOptions: SolrRequestOptionsDTO;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService,
                protected solrSvc: SolrService
    ) {
        super(http, restUrlsConf, notifySvc);
    }

    getListData(key: string = '', url: string = '', data = []): Observable<any> {
        let gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.listUrl;
        return this.http.post(gadgetUrl, key)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getGaugeData(key: string = '', url: string = ''): Observable<any> {
        let gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.gaugeUrl;
        return this.http.post(gadgetUrl, key)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getCardData(key: string = '', url: string = '', data = []): Observable<any> {
        let gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.cardUrl;
        return this.http.post(gadgetUrl, key)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getBarData(key: string = '', url: string = ''): Observable<any> {
        let gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.barUrl;
        return this.http.post(gadgetUrl, key)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getBar2Data(key: string = '', url: string = ''): Observable<any> {
        let gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.bar2Url;
        return this.http.post(gadgetUrl, key)
            .pipe(map((res) => res), catchError((error: any) => throwError(error)));
    }

    getPieByView(key: string = '', url: string = ''): Observable<any> {
        let gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.pieByViewUrl;
        let data = JSON.stringify({ view: key });
        return this.http.post(gadgetUrl, data)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getGridData(pid: string, key: string, url: string = '', attributes = {}, solrAttributes: {}): Observable<any> {
        let gadgetUrl;
        if (attributes['solr'] == 'true') {
            let options = {
                pageNumber: attributes['pageNumber'],
                filters: {},
                itemsPerPage: attributes['size'],
                isGroupBy: false
            };
            this.solrOptions = new SolrRequestOptionsDTO(Object.assign(options, solrAttributes));
            return this.solrSvc.buildSolrUrl({}, this.solrOptions, false, false)
                .pipe(map((res) => {
                    if (res['response'] && res['response']?.['docs']) {
                        res['data'] = res['response']['docs'];
                        res['numFound'] = res['response']['numFound'];
                    }
                    return res;
                }), catchError((error: any) => throwError(error)));
        } else {
            gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.gridUrl;
        }
        attributes['key'] = key;
        attributes['pId'] = pid;
        let data = JSON.stringify(attributes);
        return this.http.post(gadgetUrl, data)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getTrendBar(data: object, url: string = ''): Observable<any> {
        let gadgetUrl = url ? `${this.restUrlsConf.appURL}${url}` : this.trendBarUrl;
        return this.http.post(gadgetUrl, JSON.stringify(data))
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }


    GetFeedbackQuestions(formCollectionVar, pId): Observable<any> {
        return this.http.get(`${this.publicBaseUrl}/feedback/questions/${formCollectionVar}/${pId}.json`)
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    getOptionSelect(codescVar): Observable<any> {
        return this.http.get(`${this.analyticsPeriodUrl}/${codescVar}.json`)
            .pipe(tap((res) => res, (error: any) => throwError(error)));
    }

    getGadgetData(data: object, url = ''): Observable<any> {
         return this.http.post(`${this.restUrlsConf.appURL}${url}`, JSON.stringify(data))
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }
}
